module.exports = __webpack_public_path__ + "static/media/icn_check_future_vision.e8f96bb9.svg";